import React from 'react';
import { Team } from '../../core/typings/riders';
import { SvgImage } from '../common';
import { Container } from '../helpers/Grid';
import './styles.scss';

export interface RiderTeamHistoryProps {
  title: string;
  teams: Team[];
}

const TeamListItem = ({
  year,
  teamName,
  teamCode,
  countryCode,
  url,
  format,
}: Team) => {
  const WithLink = ({ children, ...props }: { children: JSX.Element[] }) => (url
    ? <a href={url} {...props}>{children}</a>
    : <div {...props}>{children}</div>);

  return (
    <div className="team-list-item">
      <WithLink className="team-list-item__container">
        <div className="team-list-item__year">
          {year}
        </div>
        <div className="team-list-item__team">
          <div className="team-list-item__name">
            {teamName}
          </div>
          <div className="team-list-item__team-code">
            {teamCode}
          </div>
        </div>
        <div className="team-list-item__details">
          <div className="team-list-item__format">
            {format}
          </div>
          <div className="team-list-item__country-code">
            {countryCode.replace('RUS', '***').replace('BLR', '***')}
          </div>
        </div>
        <div className="team-list-item__placeholder">
          {url && (
            <SvgImage ariaHidden title="" reference="#icon-think-arrow" />
          )}
        </div>
      </WithLink>
    </div>
  );
};

const RiderTeamHistory = ({
  title,
  teams,
}: RiderTeamHistoryProps) => (
  <section className="rider-team-history">
    <Container>
      <div className="rider-team-history__inner">
        <div className="rider-team-history__title">
          <h3>{title}</h3>
        </div>

        <div className="rider-team-history__teams-list">
          {teams.map((team) => <TeamListItem {...team} />)}
        </div>
      </div>
    </Container>
  </section>
);

export default RiderTeamHistory;
